import { render } from "./EmployeesPlannedLeaveWidget.vue?vue&type=template&id=0bb4988a&scoped=true"
import script from "./EmployeesPlannedLeaveWidget.vue?vue&type=script&lang=js"
export * from "./EmployeesPlannedLeaveWidget.vue?vue&type=script&lang=js"

import "./employee-on-leave-widget.scss?vue&type=style&index=0&id=0bb4988a&lang=scss&scoped=true&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0bb4988a"]])

export default __exports__